import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/views/assets/169.png'


const _withScopeId = n => (_pushScopeId("data-v-44f744a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "short" }
const _hoisted_2 = { class: "tags" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "current" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = { class: "video" }
const _hoisted_7 = { class: "player" }
const _hoisted_8 = {
  class: "playerId",
  ref: "video",
  id: "video"
}
const _hoisted_9 = { class: "left" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "tag" }
const _hoisted_12 = { class: "right" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-left" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-left" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "option" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-guankancishu" }, null, -1))
const _hoisted_19 = {
  key: 0,
  class: "icon i-aixin1"
}
const _hoisted_20 = {
  key: 1,
  class: "icon i-aixin"
}
const _hoisted_21 = { class: "tag" }
const _hoisted_22 = { class: "name" }

import backMusic from '@/store/backMusic';
import short, { State } from '@/store/channels/short';
import favorites from '@/store/mine/favorites';
import user from '@/store/user';
import * as filters from '@/views/filters';
import ViewContext from '@/views/ViewContext';
import { computed, inject, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const context = inject('context') as ViewContext
const store = useStore()
const router = useRouter()
const data = computed<State>(() => store.state[short.name])
const current = computed(() => data.value.video)
const player = ref<any>()
const contentsState = ref<boolean>(false)
const contents = ref<HTMLDivElement>()

onMounted(() => {
    checkVideo()
    backMusic.shutdown(store)
})

onBeforeUnmount(() => {
    if (player.value) {
        context.dispostAliPlayer('video', player.value)
    }
})

watch(current, checkVideo)

function checkVideo() {
    if (current.value.id > 0) {
        createPlayer(current.value.video)
        contentsState.value = false
        let i = data.value.videoList.findIndex(item => item.id == data.value.id)
        if (i >= 0 && contents.value) {
            let e = contents.value.children[i]
            if (e && e.scrollIntoView) {
                e.scrollIntoView()
            }
        }
    }
}

function createPlayer(source: string) {
    console.info('create player', source)
    context.dispostAliPlayer('video', player.value)
    if (!source) {
        return
    }
    player.value = context.createAliPlayer('video', source, function () {
        //@ts-ignore
    }, { isLive: false, auto: true, poster: '', rate: false })

    player.value.on('ended', () => {
        onNext()
    })
}

function onPrev() {
    if (data.value.videoList.length > 0) {
        let i = data.value.videoList.findIndex(item => item.id == data.value.id)
        i = (i + data.value.videoList.length - 1) % data.value.videoList.length
        let item = data.value.videoList[i]
        if (data.value.id != item.id) {
            router.push(`/shorts/index.html?id=` + item.id)
        }
    }
}

function onNext() {
    if (data.value.videoList.length > 0) {
        let i = data.value.videoList.findIndex(item => item.id == data.value.id)
        i = (i + 1) % data.value.videoList.length
        let item = data.value.videoList[i]
        if (data.value.id != item.id) {
            router.push(`/shorts/index.html?id=` + item.id)
        }
    }
}

function onChannel() {
    if (current.value && current.value.channel_id > 0) {
        router.push(`/channels/detail/${current.value.channel_id}.html`)
    } else {
        contentsState.value = !contentsState.value
    }
}

async function onFavorite() {
    if (user.online(store)) {
        try {
            if (data.value.isFavorite) {
                await favorites.removeShort(store, data.value.id)
                current.value.favs = Math.max(0, current.value.favs - 1)
            } else {
                await favorites.addShort(store, data.value.id)
                current.value.favs++
            }
            data.value.isFavorite = !data.value.isFavorite
        } catch (e) {
        }
    }
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).tags, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          class: _normalizeClass({ on: item.tag == _unref(data).tag }),
          to: `/shorts/index.html?tag=${item.tag}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(" #" + _toDisplayString(item.tag) + "# ", 1)
          ]),
          _: 2
        }, 1032, ["class", "to"]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, null, 512),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(current).title), 1),
              _createElementVNode("div", _hoisted_11, "#" + _toDisplayString(_unref(current).tag) + "#", 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", { class: "change" }, [
                _createElementVNode("a", {
                  class: "prev",
                  onClick: onPrev
                }, _hoisted_14),
                _createElementVNode("a", {
                  class: "next",
                  onClick: onNext
                }, _hoisted_16)
              ]),
              _createElementVNode("a", {
                class: "channel",
                style: _normalizeStyle(_unref(filters).bg(_unref(current).avatar)),
                onClick: onChannel
              }, null, 4),
              _createElementVNode("span", _hoisted_17, [
                _hoisted_18,
                _createTextVNode(_toDisplayString(_unref(current).hits), 1)
              ]),
              _createElementVNode("a", {
                class: _normalizeClass(["option", { on: _unref(data).isFavorite }]),
                onClick: onFavorite
              }, [
                (_unref(data).isFavorite)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                  : (_openBlock(), _createElementBlock("i", _hoisted_20)),
                _createTextVNode(" " + _toDisplayString(_unref(current).favs), 1)
              ], 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["contents", { active: contentsState.value }]),
        ref_key: "contents",
        ref: contents
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).videoList, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            class: _normalizeClass(["item", { active: _unref(current).id === item.id }]),
            to: `/shorts/index.html?id=${item.id}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "cover",
                style: _normalizeStyle(_unref(filters).bg(item.thumb))
              }, [
                _createElementVNode("span", _hoisted_21, "#" + _toDisplayString(item.tag) + "#", 1)
              ], 4),
              _createElementVNode("div", _hoisted_22, _toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"]))
        }), 256))
      ], 2)
    ])
  ]))
}
}

})